"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CardPickerHeader = _interopRequireDefault(require("./CardPickerHeader"));

var _CardPickerContent = _interopRequireDefault(require("./CardPickerContent"));

var _Icons = require("../../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardPicker = function CardPicker(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      children = _ref.children,
      className = _ref.className,
      otherProps = _ref.otherProps;
  return /*#__PURE__*/_react.default.createElement(StyledCardPicker, _extends({
    active: active,
    disabled: disabled,
    onClick: onClick,
    className: className
  }, otherProps), children, active ? /*#__PURE__*/_react.default.createElement(SelectedBox, null, /*#__PURE__*/_react.default.createElement(_Icons.IconStatusCheck, {
    size: 20
  }), /*#__PURE__*/_react.default.createElement("p", null, "Selected")) : null);
};

var StyledCardPicker = _styledComponents.default.div.withConfig({
  displayName: "StyledCardPicker"
})(["width:100%;max-width:100rem;border:", ";background:white;box-sizing:border-box;box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);border-radius:5px;position:relative;cursor:", ";opacity:", ";user-select:", ";transition:box-shadow 0.15s ease-in-out;&:hover{box-shadow:", ";}"], function (_ref2) {
  var theme = _ref2.theme,
      active = _ref2.active;
  return active ? "2px solid ".concat(theme.brand.primary) : '2px solid #f0f1f3';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? '.5' : '1';
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'none' : null;
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return !disabled ? "0 0 1px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.04),\n      0 16px 24px rgba(0, 0, 0, 0.04), 0 24px 32px rgba(0, 0, 0, 0.04)" : null;
});

var SelectedBox = _styledComponents.default.div.withConfig({
  displayName: "SelectedBox"
})(["position:absolute;bottom:1.6rem;right:1.6rem;background-color:", ";display:flex;justify-content:flex-start;align-items:center;border-radius:9999px;padding:0.2rem 0.8rem;box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);> svg path{fill:white;}> p{margin-left:1.2rem;font-family:", ";font-weight:400;font-size:1.2rem;line-height:120%;color:white;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.brand.primary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.font;
});

CardPicker.propTypes = {
  /** Defines wether or not the element should display active styling. */
  active: _propTypes.bool,

  /** Defines wether or not the element is enabled. */
  disabled: _propTypes.bool,

  /** Function to be executed when the element is clicked. */
  onClick: _propTypes.func,

  /** Content of the element. */
  children: _propTypes.element.isRequired,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
CardPicker.Header = _CardPickerHeader.default;
CardPicker.Header.displayName = 'CardPicker.Header';
CardPicker.Content = _CardPickerContent.default;
CardPicker.Content.displayName = 'CardPicker.Content';
var _default = CardPicker;
exports.default = _default;